import axios from 'axios'
import { AvailableLang, Lang } from '@app/types/src/Lang'
import Cookie from 'js-cookie'
import { accountModule } from '@app/utils/store-accessor'

const langDictionaly: Record<string, string> = {
  [AvailableLang.JP]: 'ja',
  [AvailableLang.KR]: 'ko',
  [AvailableLang.TW]: 'zh-TW',
  [AvailableLang.HK]: 'zh-HK',
  [AvailableLang.EN]: 'en',
  [AvailableLang.VN]: 'vi',
  [AvailableLang.CN]: 'zh-TW',
}

const defaultLang = AvailableLang.EN

const countryList: string[] = []
for (const langDictionalyKey in langDictionaly) {
  countryList.push(langDictionalyKey)
}
// https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2 国コード
async function getUserCountry() {
  const res = await axios.get(
    'https://asia-northeast1-care-pro-c1b38.cloudfunctions.net/core/v1/ip/country'
  )
  if (useEN(res.data.country)) {
    return {
      country: AvailableLang.EN,
    }
  } else {
    return res.data
  }
}
function useEN(lang: Lang) {
  return (
    lang !== AvailableLang.JP &&
    lang !== AvailableLang.KR &&
    lang !== AvailableLang.TW &&
    lang !== AvailableLang.HK &&
    lang !== AvailableLang.VN &&
    lang !== AvailableLang.CN
  )
}
export function getUserLangFromCookie(): Lang {
  return Cookie.get('cpUserSelectedLang') as Lang
}

export async function checkLang() {
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('lang')) {
    const lang = urlParams.get('lang')
    if (isAvailableLang(lang)) {
      accountModule.setLanguage(lang as Lang)
    }
    return
  }
  await accountModule.getUser().catch((e) => {
    console.log('getUser error', e)
  })
  const cookieKey = 'cpUserCountry'
  if (Cookie.get('cpIsUserSelectedLang') == '1') {
    const lang = getUserLangFromCookie()
    accountModule.setLanguage(lang as Lang)
    return
  }

  let userCountry
  if (Cookie.get(cookieKey)) {
    userCountry = Cookie.get(cookieKey)
  } else {
    const res = await getUserCountry()
    userCountry = countryList.includes(res.country) ? res.country : defaultLang
    Cookie.set(cookieKey, userCountry, { expires: 1, path: '/' })
  }
  accountModule.setLanguage(userCountry)
  try {
    await accountModule.updateLanguage()
  } catch (e) {
    console.log(e)
  }
}

export function setLang(lang: Lang) {
  try {
    change(lang)
  } catch (e) {
    console.log(e)
  }
  Cookie.set('cpIsUserSelectedLang', '1')
  Cookie.set('cpUserSelectedLang', lang)

  accountModule.updateLanguage()?.catch((e) => {
    console.log(e)
  })
}

export function isAvailableLang(lang: string | null) {
  for (const availableLangKey in AvailableLang) {
    if (availableLangKey === lang) return true
  }
  return false
}

// 言語を切り替えるときにshuttoが初期化されていない可能性があるためリトライ処理を入れる
let retryTimer: NodeJS.Timeout | null = null
function change(lang: Lang) {
  if (!langDictionaly[lang]) return
  // @ts-ignore
  if (!window.__stt) {
    retryTimer = setTimeout(() => {
      change(lang)
    }, 500)
  } else {
    clearTimeout(retryTimer as NodeJS.Timeout)
    retryTimer = null
    // @ts-ignore
    window.__stt.set('lang', langDictionaly[lang])
  }
}
